import { useMediaQuery } from "@mui/material";
import { isEqual } from "lodash";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ReactJoyride from "react-joyride";
import { useSelector } from "react-redux";

const JoyrideMobileComponent = ({
  isJoyrideActive,
  joyrideSteps,
  handleJoyrideCallback,
  currentStep,
  totalSteps,
}) => {
  const { i18n } = useTranslation();
  const app = useSelector((state) => state.app, isEqual);
  const customLocale = {
    back: i18n.t("common.BACK"),
    close: i18n.t("common.END_TOUR"),
    last: i18n.t("common.FINISH"),
    next: i18n.t("common.NEXT"),
    skip:i18n.t("common.SKIP")
  };

  const isMobile = useMediaQuery("(max-width:767px)");

  useEffect(() => {
    if (isJoyrideActive) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [isJoyrideActive]);

  return (
    <div style={{ overflow: "hidden" }}>
      {
      isMobile && 
      (
        <ReactJoyride
          steps={joyrideSteps}
          styles={{
            options: {
              backgroundColor: app.theme === "dark" ? "#1B1B1B" : "white",
              textColor: app.theme === "dark" ? "white" : "#1B1B1B",
              zIndex: 10000,
            },
            buttonNext: {
              backgroundColor: "#5d5fef",
              color: "white",
            },
            buttonSkip: {
              cursor: "pointer",
              backgroundColor: "#5d5fef",
              border: "0px",
              borderRadius: "4px",
              color: "rgb(255, 255, 255)",
              cursor: "pointer",
              fontSize: "16px",
              lineHeight: "1",
              padding: "8px",
              marginRight: "5px",
            },
            buttonBack: {
              backgroundColor: "white",
              color: "#5d5fef",
            },
            buttonClose: {
              display: currentStep === totalSteps - 1 ? "none" : "block",
            },
            beacon: {
              marginLeft: "30px",
            },
          }}
          continuous={true}
          callback={handleJoyrideCallback}
          run={isJoyrideActive}
          hideCloseButton={true}
          disableScrolling={true}
          showSkipButton={true}
          showProgress
          // disableOverlay={true}
          disableOverlayClose={true}
          locale={customLocale}
        />
      )}
    </div>
  );
};

export default JoyrideMobileComponent;
